"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftValidationResult = instanceOfShiftValidationResult;
exports.ShiftValidationResultFromJSON = ShiftValidationResultFromJSON;
exports.ShiftValidationResultFromJSONTyped = ShiftValidationResultFromJSONTyped;
exports.ShiftValidationResultToJSON = ShiftValidationResultToJSON;
exports.ShiftValidationResultToJSONTyped = ShiftValidationResultToJSONTyped;
/**
 * Check if a given object implements the ShiftValidationResult interface.
 */
function instanceOfShiftValidationResult(value) {
    if (!('shiftId' in value) || value['shiftId'] === undefined)
        return false;
    if (!('nurseProfileId' in value) || value['nurseProfileId'] === undefined)
        return false;
    if (!('removed' in value) || value['removed'] === undefined)
        return false;
    return true;
}
function ShiftValidationResultFromJSON(json) {
    return ShiftValidationResultFromJSONTyped(json, false);
}
function ShiftValidationResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'shiftId': json['shiftId'],
        'nurseProfileId': json['nurseProfileId'],
        'removed': json['removed'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}
function ShiftValidationResultToJSON(json) {
    return ShiftValidationResultToJSONTyped(json, false);
}
function ShiftValidationResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'shiftId': value['shiftId'],
        'nurseProfileId': value['nurseProfileId'],
        'removed': value['removed'],
        'reason': value['reason'],
    };
}
//# sourceMappingURL=ShiftValidationResult.js.map